import React, { useEffect, useState } from 'react'
import CustomLoader from '../custom-modules/CustomLoader';
import * as Global from "../../constants/Global";
import { useAlert } from "react-alert";
import * as DataHandler from '../../utility-files/data-util/DataHandler'
import { getRequestForApi } from '../../utility-files/api-util/CommonRequest';
import { callHttpRequest, methodType } from "../../utility-files/api-util/HttpRequest";
import { alertTypes} from "../../utility-files/helper-function/HelperFunction";

function ApproveStatus({ isShow, onClose, userId,onSuccess }) {
    const alert = useAlert();
    const[pending,setPending] = useState(false);
    const[approveStatus,setApproveStatus] = useState(null);

     const usersStatus = async () => {
            let variables = {
                userId: DataHandler.isStringValue(userId),
            };
            setPending(true);
            let request = getRequestForApi(Global.GET_STATUS_MANUFACTURER, variables, methodType.POST)
            await callHttpRequest(request).then((response) => {
                if (response?.status === 201) {
                    alert.show(response?.data?.status, { type: alertTypes.SUCCESS });
                    setApproveStatus(false);
                    onSuccess();
                    onClose();
                };
                setPending(false);
            }).catch((err) => {
                alert.show(err?.response?.data?.message, { type: alertTypes.ERROR });
                setPending(false)
            })
        };
   
    return (
        <div className={`modal ${isShow ? "modal-show" : "fade"}`} id={userId} tabIndex="-1" role="dialog" aria-labelledby={userId} aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
            {<CustomLoader pending={pending} />}
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header hide-border">
                        <div className="modal-head">
                            <h5 className="modal-title" id="exampleModalLabel">Are you sure you want to approve registration for this Manufacturer?</h5>
                        </div>
                    </div>
                    <div className="modal-footer hide-border mt-3">
                        <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal"  onClick={() => { onClose()}}>No</button>
                        <button type="button" className="btn  btn-primary btn-sm" data-bs-dismiss="modal"  onClick={(e) => usersStatus(e)}>Yes</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ApproveStatus
